const headerMenuConfig = [];
const asideMenuConfig = [
    {
        name: '数据页面',
        path: '/',
        icon: 'chart-pie',
        children: [
            {
                name: '工作台',
                path: '/workplace',
            },
            {
                name: '监控页面',
                path: '/monitor',
            },
        ],
    },
    {
        name: '设置页面',
        path: '/sc',
        icon: 'set',
        children: [
            {
                name: '系统设置',
                path: '/sc/settings',
            },
        ],
    },
    {
        name: '登录',
        path: '/user/login',
        icon: 'account',
    },
];

export { headerMenuConfig, asideMenuConfig };
